import isNil from 'lodash/isNil';
import React from 'react';
import {
  Controller,
  useFormContext,
} from 'react-hook-form';
import Wrapper from 'pages/Dashboard/components/Input/Wrapper';
import MaskedTextField from 'core/components/MaskedTextField';
import clsx from 'clsx';

const validateValueIfPremature = (age: number, value: number) => (
  age < 19 ? !isNil(value) && value > 0 : true
);

type Props = {
  className?: string;
 };

const weightMask = [
  { mask: '' },
  {
    mask: 'weight lbs',
    overwrite: true,
    lazy: false,
    eager: true,
    blocks: {
      weight: {
        mask: Number,
        min: 1,
        max: 599,
        scale: 0,
      },
    },
  },
];

export default function WeightInput({ className }: Props) {
  const { control, watch } = useFormContext();
  const age = watch('age');
  const validateWeight = (value: number) => validateValueIfPremature(age, value);

  return (
    <Controller
      name="weight"
      control={control}
      rules={{ validate: validateWeight }}
      render={({ field: { value, onChange, ...field }, fieldState: { error } }) => (
        <Wrapper
          id="weight"
          className={clsx('w-1/2', className)}
          label="Weight"
          showErrorText={false}
          error={!isNil(error)}
        >
          <MaskedTextField
            {...field}
            mask={weightMask}
            unmask
            className="w-1/2"
            error={!isNil(error)}
            maskedPosition={{ start: 0, end: 4 }}
            showErrorText={false}
            placeholder="e.g 127 lbs"
            value={value?.toString() ?? ''}
            id="weight"
            onAccept={onChange}
          />
        </Wrapper>
      )}
    />
  );
}
